import get from 'transmute/get';
import { getSenders, getSenderDeliveryIdentifierValue, getSenderDeliveryIdentifierType } from '../../../common-message-format/operators/commonMessageGetters';
import { COMMON_MESSAGE } from '../../../common-message-format/constants/messageTypes';
import { HS_EMAIL_ADDRESS } from '../../../common-message-format/constants/deliveryIdentifierTypes';
const SAMPLE_CONTACT_EMAIL = 'emailmaria@hubspot.com';

/**
 * Checks if a message is from a sample contact.
 *
 * A message is considered from a sample contact if:
 * - It is a COMMON_MESSAGE type
 * - One of its senders has an HS_EMAIL_ADDRESS delivery identifier
 * - That email address matches the SAMPLE_CONTACT_EMAIL
 *
 * @param message - The message to check
 * @returns true if the message is from a sample contact, false otherwise
 */
export function isSampleContactMessage(message) {
  if (get('@type', message) !== COMMON_MESSAGE) {
    return false;
  }
  const messageSenders = getSenders(message);
  if (!messageSenders) {
    return false;
  }
  return messageSenders.some(sender => {
    const deliveryIdentifierType = getSenderDeliveryIdentifierType(sender);
    const deliveryIdentifierValue = getSenderDeliveryIdentifierValue(sender);
    return deliveryIdentifierType === HS_EMAIL_ADDRESS && deliveryIdentifierValue === SAMPLE_CONTACT_EMAIL;
  });
}

/**
 * Finds the ID of the first message that should show the Customer Agent CTA.
 *
 * @param messagesArray - Array of messages to search through
 * @param isUngatedForCustomerAgentDiscoverability - Whether the user is ungated
 * @returns The message ID of the first eligible message, or null if none found
 */
export function getSampleMessageId(messagesArray, isUngatedForCustomerAgentDiscoverability) {
  if (!isUngatedForCustomerAgentDiscoverability) {
    return null;
  }
  for (const message of messagesArray) {
    if (isSampleContactMessage(message)) {
      return message.id || null;
    }
  }
  return null;
}